import { Checkbox as MantineCheckbox } from '@mantine/core';
import { ComponentProps } from 'react';

import styles from './checkbox.module.scss';

type CheckboxProps = ComponentProps<typeof MantineCheckbox>;

export function Checkbox(props: CheckboxProps) {
  return (
    <MantineCheckbox
      {...props}
      classNames={{
        input: styles.checkbox,
      }}
    />
  );
}
